import { reactive } from "vue";

const state = reactive({
  blockMenuOpen: false,
});

export function useEditorMenuState() {
  return state;
}
